import { useTran } from "@/hooks";
import { Card } from "@/components/ui/card";
import { Textarea } from "@/components/ui/textarea";
import { InputField } from "@/components/common";

import SurveyCompanySelector from "./SurveyCompanySelector";

const SurveyDetailsCard = ({
  form,
  isStandard,
  disabled,
  companies,
  companySearch,
  onCompanySearchChange,
  onModeChange,
  onToggleCompany,
  onFieldChange,
}) => {
  const { t } = useTran();

  return (
    <Card className="space-y-4 border border-border bg-card p-5 shadow-sm">
      <div>
        <p className="text-sm font-semibold text-foreground">
          {isStandard ? t("Standard Survey") : t("Custom Survey")}
        </p>
        <p className="text-xs text-muted-foreground">
          {t("Define survey details and respondent scope.")}
        </p>
      </div>
      <InputField
        label={t("Survey Title")}
        labelClassName="text-xs font-semibold uppercase tracking-wide text-muted-foreground"
        value={form.title}
        onChange={(event) => onFieldChange("title", event.target.value)}
        placeholder={t("Enter survey title")}
        disabled={disabled}
      />
      <div className="space-y-2">
        <label className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
          {t("Description")}
        </label>
        <Textarea
          value={form.description}
          onChange={(event) => onFieldChange("description", event.target.value)}
          placeholder={t("Optional description")}
          disabled={disabled}
        />
      </div>

      <SurveyCompanySelector
        companies={companies}
        selectedCompanyIds={form.selectedCompanyIds}
        companySelectionMode={form.companySelectionMode}
        searchValue={companySearch}
        onSearchChange={onCompanySearchChange}
        onModeChange={onModeChange}
        onToggleCompany={onToggleCompany}
        disabled={disabled}
      />

      <InputField
        label={t("Expires at")}
        labelClassName="text-xs font-semibold uppercase tracking-wide text-muted-foreground"
        type="date"
        value={form.expiresAt}
        onChange={(event) => onFieldChange("expiresAt", event.target.value)}
        disabled={disabled}
      />
    </Card>
  );
};

export default SurveyDetailsCard;
